import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_ORDERING_PRACTITIONERS } from "config/connString";

const deleteOrderingPractitioner = createAsyncThunk(
  "ordering-practitioners/delete-ordering-practitioner",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.delete(
        URL_ORDERING_PRACTITIONERS + "/" + data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { deleteOrderingPractitioner };
